<template>
   <svg
      class="size-5"
      viewBox="0 0 39 38"
      fill="none"
      stroke="currentColor"
      stroke-width="2.4"
      aria-hidden="true"
      focusable="false"
   >
      <circle cx="19.75" cy="19" r="18" />
      <path
         d="M26.9432 19C26.9432 24.1438 26.0421 28.7531 24.625 32.039C23.9158 33.6837 23.0969 34.9511 22.2386 35.793C21.3847 36.6304 20.5448 37 19.7494 37C18.954 37 18.1141 36.6304 17.2603 35.793C16.4019 34.9511 15.5831 33.6837 14.8738 32.039C13.4567 28.7531 12.5557 24.1438 12.5557 19C12.5557 13.8562 13.4567 9.24691 14.8738 5.96097C15.5831 4.3163 16.4019 3.04891 17.2603 2.20705C18.1141 1.36955 18.954 1 19.7494 1C20.5448 1 21.3847 1.36955 22.2386 2.20705C23.0969 3.04891 23.9158 4.3163 24.625 5.96097C26.0421 9.24691 26.9432 13.8562 26.9432 19Z"
      />
      <line x1="2.8877" y1="12.2124" x2="36.1377" y2="12.2124" />
      <line x1="2.8877" y1="25.3188" x2="36.1377" y2="25.3188" />
   </svg>
</template>
